/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-08-06 10:02:35
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-06 10:21:32
 */
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormat } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    // {
    //   title: '门店名称',
    //   dataIndex: 'tenantMaterialsCatalogId',
    //   align: 'center',
    //   width: '8rem',
    //   ellipsis: true,
    // },
    {
      title: '设备编号',
      dataIndex: 'deviceNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.deviceNumber ? t.deviceNumber : '-'
      },
    },
    {
      title: '设备名称',
      dataIndex: 'deviceName',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.deviceName ? t.deviceName : '-'
      },
    },
    {
      title: '规格型号',
      dataIndex: 'model',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.model ? t.model : '-'
      },
    },
    {
      title: '养护时间',
      dataIndex: 'maintainTime',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.maintainTime ? moment(t.maintainTime).format(DateTimeFormat) : '-'
      },
    },
    {
      title: '处理措施',
      dataIndex: 'handlingMeasures',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.handlingMeasures ? t.handlingMeasures : '-'
      },
    },
    {
      title: '操作人',
      dataIndex: 'operator',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.operator ? t.operator : '-'
      },
    },
    {
      title: '备注',
      dataIndex: 'remark',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.remark ? t.remark : '-'
      },
    },
  ]
}
